/**
 * What the landing film shows, as the builder reports it.
 *
 * The frames in public/assets/landing/film/ are renders of the two-room
 * builder with the lakeside preset applied to a fresh draft. These
 * figures are the ones that same draft shows in the builder's workspace tabs.
 * They are copied here rather than computed so the landing page does not ship
 * the engines; `filmFacts.test.tsx` rebuilds the draft through the store and
 * the builder's own derived-data hook and fails when any figure drifts.
 */
export const FILM_FACTS = {
	/** Two-room preset the film was rendered with. */
	preset: "lakeside",
	widthMm: 3000,
	lengthMm: 4000,
	/** Rows on the shopping tab. */
	purchaseRows: 72,
	/** Rows on the cut-list tab — lines, not pieces. */
	cutListRows: 71,
	/** Estimated material cost, in SEK; formatted per market at render. */
	materialCostSek: 142_247,
} as const;

/** Number of frames in the film, f000 … f095. */
export const FILM_FRAME_COUNT = 96;
